import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";

export const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-ocean text-sand mt-32">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20">
        <div className="grid md:grid-cols-4 gap-12">
          <div className="md:col-span-2">
            <Logo tone="white" className="h-20 w-auto mb-4" />
            <div className="font-script text-3xl text-sunkissed mb-6">Salt Love</div>
            <p className="text-sand/70 max-w-sm leading-relaxed text-sm">
              Made-to-measure swimwear, cut to your exact body from three photos.
              Tailored for sun kissed days and salty skin. Born by the sea.
            </p>
          </div>
          <div>
            <div className="overline text-sand/50 mb-5">Shop</div>
            <ul className="space-y-3 text-sm">
              <li><Link to="/women" className="hover:text-sunkissed transition-colors">Women</Link></li>
              <li><Link to="/men" className="hover:text-sunkissed transition-colors">Men</Link></li>
              <li><Link to="/swimwear" className="hover:text-sunkissed transition-colors">All Swimwear</Link></li>
              <li><Link to="/fit-studio" className="hover:text-sunkissed transition-colors">Fit Studio</Link></li>
            </ul>
          </div>
          <div>
            <div className="overline text-sand/50 mb-5">Atelier</div>
            <ul className="space-y-3 text-sm text-sand/70">
              <li>海を愛する · Love the Sea</li>
              <li>Handcrafted to order</li>
              <li>Italian &amp; recycled fabrics</li>
              <li>Ships worldwide</li>
            </ul>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-sand/15 flex flex-col md:flex-row justify-between gap-4 text-xs text-sand/50">
          <span>© {new Date().getFullYear()} SHIOKOI · shiokoi.com</span>
          <span>For the love of salt.</span>
        </div>
      </div>
    </footer>
  );
};
